export const RADIO_EXAM = [
  {
    title: 'Ya',
    value: 'Ya',
  },
  {
    title: 'Tidak',
    value: 'Tidak',
  },
];

export const RADIO_AGE_GROUP = [
  {
    title: 'Neonatus',
    value: 'NEO',
  },
  {
    title: 'Anak',
    value: 'PEDS',
  },
  {
    title: 'Dewasa',
    value: 'ADULT',
  },
  {
    title: 'Geriatri',
    value: 'GERIATRIC',
  },
];

export const RADIO_PRIORITY = [
  {
    title: 'Elektif',
    value: 'ELECTIVE',
  },
  {
    title: 'Darurat',
    value: 'EMERGENCY',
  },
];

export const RADIO_LOCATION = [
  {
    title: 'RSCM',
    value: 'RSCM',
  },
  {
    title: 'Dharmais',
    value: 'Dharmais',
  },
  {
    title: 'Harapan Kita',
    value: 'Harapan Kita',
  },
  {
    title: 'RSUD Tangerang',
    value: 'RSUD Tangerang',
  },
  {
    title: 'Ruteng',
    value: 'Ruteng',
  },
  {
    title: 'Natuna',
    value: 'Natuna',
  },
  {
    title: 'Fatmawati',
    value: 'Fatmawati',
  },
  {
    title: 'Persahabatan',
    value: 'Persahabatan',
  },
  {
    title: 'RS Jejaring',
    value: 'RS Jejaring',
  },
  {
    title: 'Lainnya',
    value: 'Lainnya',
  },
];

export const RADIO_GENDER = [
  {
    title: 'Laki - Laki',
    value: 'MALE',
  },
  {
    title: 'Perempuan',
    value: 'FEMALE',
  },
];

export const RADIO_EMERGENCY = [
  {
    title: 'Ya',
    value: 'ya',
  },
  {
    title: 'Tidak',
    value: 'tidak',
  },
];
